import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const AccessButtonWrapper = styled.div`
  ${FLEX.FlexBetweenCenter};
  gap: 10px;
  padding: 0 30px;
  width: 100%;
  > div {
    ${FLEX.FlexStartCenter};
    gap: 10px;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  ${mediaQuery.isMobile} {
    padding: 0;
    button {
      width: auto;
    }
  }
`;
export const InvitationButtonWrapper = styled(AccessButtonWrapper)`
  justify-content: center;
`;

export const AccessNotifyWrapper = styled.div`
  padding: 10px 20px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 10px;
  .account-id-label {
    line-height: 1.4;
  }
  p {
    line-height: 1.2;
    text-align: left;
  }
  b {
    font-weight: 500;
  }
  ${mediaQuery.isMobile} {
    padding: 10px 0;
  }
`;
export const AccessNotifyTitle = styled.h3`
  font-size: ${calcRem(20)};
  font-weight: 500;
  ${FLEX.FlexStartCenter};
  gap: 10px;
  padding-bottom: 10px;
`;

export const AccessNotifyContent = styled.p`
  line-height: 1.2;
  max-width: 600px;
  label {
    font-size: ${calcRem(12)};
    color: ${({ theme }) => `${theme.COLORS.WHITE}70`};
    padding: 10px 0 5px 0;
  }
  b {
    font-size: ${calcRem(16)};
    font-weight: 500;
  }
`;
